import React, { useContext } from 'react';
import { AppSidebar, AppSidebarMenuItem } from '@redpanda/ui';
import {
  PresentationChartBarIcon,
  QueueListIcon,
  ChartBarIcon,
  BuildingStorefrontIcon,
} from '@heroicons/react/24/outline';
import ThemeSelector from './ThemeSelector';
import { useTranslation } from 'react-i18next';
import { UserContext } from '../context/UserContext';

interface SidebarProps {
  className?: string;
  isMobileOpen?: boolean;
  onCloseMobile?: () => void;
}

const menuItems: AppSidebarMenuItem[] = [
  { path: '/admin/dashboard', labelKey: 'navigation.dashboard', icon: PresentationChartBarIcon },
  { path: '/admin/queue', labelKey: 'navigation.queueManagement', icon: QueueListIcon },
  { path: '/admin/analytics', labelKey: 'navigation.analytics', icon: ChartBarIcon },
  { path: '/admin/settings', labelKey: 'navigation.settings', icon: BuildingStorefrontIcon },
];

const Sidebar: React.FC<SidebarProps> = (props) => {
  const { user, logout, language, updateUserLanguage } = useContext(UserContext)!;
  const { t, i18n } = useTranslation();

  return (
    <AppSidebar
      appName={t('app.title')}
      logoPath="/admin/dashboard"
      menuItems={menuItems}
      user={user}
      currentLanguage={language || i18n.language}
      onLanguageChange={(lng) => {
        if (updateUserLanguage) updateUserLanguage(lng as 'zh' | 'en' | 'ja');
        else i18n.changeLanguage(lng);
      }}
      onLogout={logout}
      themeSelector={<ThemeSelector />}
      currentSystem="QUEUE"
      profilePath="/admin/profile"
      adminPath="/admin/admin"
      manualPath="/admin/manual"
      {...props}
    />
  );
};

export default Sidebar;
